import { createHttpLink } from '@apollo/client';

import config from '@ui-furniture/config';

export const apiHttpLink = createHttpLink({
  uri: `${config.backendDomain}/graphql`,
  credentials: 'include',
});
